// extracted by mini-css-extract-plugin
export var buttons = "_4h-0";
export var buttonsActive = "_4h-h";
export var cancelConfirm = "_4h-1";
export var closeButton = "_4h-2";
export var column = "_4h-3";
export var container = "_4h-4";
export var detailHeader = "_4h-6";
export var detailTitle = "_4h-7";
export var detailsContent = "_4h-5";
export var header = "_4h-8";
export var headerWithClose = "_4h-9";
export var icon = "_4h-a";
export var infoIcon = "_4h-c";
export var informationContainer = "_4h-b";
export var sideDrawer = "_4h-d";
export var sideDrawerOpen = "_4h-e";
export var stickyFooter = "_4h-f";
export var typeOption = "_4h-g";